import React from 'react';
import Tooltip from '../Tooltip';
import Icon from '../../kingpin/atoms/Icon';

import styled from 'styled-components';

const IconSize = styled.div`
  display: flex;
  svg {
    width: 16px;
    height: 16px;
  }
`;

const InfoIcon = ({
  tooltip,
  isGrey,
}: {
  tooltip?: string;
  isGrey?: boolean;
}) => (
  <div style={{ cursor: 'help' }}>
    <Tooltip content={tooltip}>
      <IconSize>
        <Icon
          icon={'info'}
          color={isGrey ? 'var(--color-grey-3)' : 'var(--color-brand-dark)'}
        />
      </IconSize>
    </Tooltip>
  </div>
);

export const InfoIconNoTooltip = ({
  testId,
  isSmall,
}: {
  testId?: string;
  isSmall?: boolean;
}) => (
  <div data-testid={testId} style={{ cursor: 'help', display: 'flex' }}>
    <Icon
      icon={'info'}
      color={isSmall ? 'var(--color-text-disabled)' : 'var(--color-grey-3)'}
      width={isSmall ? 14 : undefined}
      height={isSmall ? 14 : undefined}
    />
  </div>
);

export default InfoIcon;
